<template>
  <div class="examSystem">
    <common-breadcrumb />
    <div class="conWrap"
         v-show="showStatus">
      <div class="th clearfix">
        <div class="intro">
          <h3>{{ categoryTitle }}</h3>
          <table class="tips">
            <tr>
              <th>逼<i style="display:inline-block;width:14px;"></i>真：</th>
              <td>模拟计算机考试，感受真实的考试场景</td>
            </tr>
            <tr>
              <th>含金量：</th>
              <td>紧扣教学大纲和考试要求，全面覆盖各类知识点</td>
            </tr>
            <tr>
              <th>效<i style="display:inline-block;width:14px;"></i>果：</th>
              <td>海量题库，随机抽题组卷，评估自己的水平</td>
            </tr>
          </table>
          <a href="javascript:void(0)"
             class="startExam"
             @click="startExam" />
        </div>
        <div class="blessings"
             v-html="blessingsConvert"></div>
      </div>
      <div class="th clearfix">
        <div class="preexam">
          <iframe v-if="preExamUrl"
                  :src="preExamUrl"
                  frameborder="0"
                  width="440px"
                  height="140px"
                  marginwidth="10"
                  marginheight="10"
                  hspace="0"
                  vspace="0"
                  scrolling="no" />
        </div>
        <div class="questions">
          <h3>常见问题</h3>
          <ul>
            <li><a href="javascript:void(0)"
                 @click="custormAnchor('F1')">机考系统常见拼音输入法</a></li>
            <li><a href="javascript:void(0)"
                 @click="custormAnchor('F2')">模拟考试系统可以自动判卷吗？</a></li>
            <li><a href="javascript:void(0)"
                 @click="custormAnchor('F2')">错题可以重做吗？</a></li>
            <li><a href="javascript:void(0)"
                 @click="custormAnchor('F2')">模拟考试和真实考试一样吗？</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="questions-con"
         v-show="!showStatus">
      <div class="mrtext">
        <h2>常见问题</h2>
        <div class="mainrtext">
          <div id="F1">
            <p><strong>机考系统中常见拼音输入法：</strong></p>
            <p>根据国家机考系统要求，机考系统中会有6种输入法供考生选择，即微软拼音输入法、谷歌拼音输入法、搜狗拼音输入法、王码五笔型输入法、极品五笔输入法、万能五笔输入法。不提供手写板等辅助输入设备与软件。</p>
            <p>网校建议您使用机考系统要求的输入法进行打字练习，以提高机考时的答题速度。</p>
            <p>输入法下载地址：</p>
            <p>搜狗拼音输入法：http://pinyin.sogou.com/</p>
            <p>极品五笔输入法：http://www.jpwb.net/</p>
            <p>万能五笔输入法：http://www.wnwb.com/</p>
            <p>微软拼音输入法： windows 系统自带</p>
            <p>王码五笔型输入法： windows 系统自带</p>
          </div>
          <p><strong>功能说明： </strong></p>
          <p><strong>模拟考试系统：</strong>模拟真实考试环境，考生的专业无纸化考试模拟平台。严格按照考试要求编写试题，题目紧扣考试大纲，知识点覆盖全面。时间提醒、按时交卷、自动评分、答案解析、错题收藏等人性化系统提示让学员提前进入考试状态。
          </p>
          <p><strong>考试记录：</strong>统计试题正确率，分析试卷题目，让学员了解自己复习的薄弱点，并设有重做试卷、重做错题等功能。</p>
          <p><strong>错题记录：</strong>对于模拟试卷中做错的题目，学员可有针对性地再次选做，巩固薄弱知识点。</p>
          <p><strong>答案解析：</strong>按考试要求智能组卷，自动判卷，答案解析凝结了网校名师对考题的深刻理解，能够帮助考生高屋建瓴地理解历年考题的命题思路和解题方法。</p>
          <div id="F2">
            <p><strong>常见问题： </strong></p>
            <p><strong><a href="javascript:void(0)"
                   name="mkcy">1.模拟考试系统可以重复使用吗？</a></strong></p>
            <p>可以，系统会就考试中每个知识点汇总出题，针对性强，我们将提供题库升级服务。 </p>
            <p><strong><a href="javascript:void(0)"
                   name="mkpj">2.模拟考试系统可以自动判卷吗？</a></strong></p>
            <p>无纸化考试模拟结束后，系统会自动批阅试卷并显示得分，您可以查看考试成绩，系统还会统计出您做题的正确率。</p>
            <p><strong><a href="javascript:void(0)"
                   name="ctcz">3.错题可以重做吗？</a></strong></p>
            <p>系统会记录下每次答题情况，您可以将错题调出重做，反复练习，加深印象。 </p>
            <p><strong><a href="javascript:void(0)"
                   name="mkzs">4.无纸化考试模拟和真实考试一样吗？</a></strong></p>
            <p>无纸化模拟考试系统是根据往年考试情况进行的模拟仿真考试，仅供考生模拟使用，非真实考试。 </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CommonBreadcrumb } from '@components/common'
import mixinFilter from '@/mixins'
import mixinCl from '@/mixins/checkLogged'
import { title } from '@base/settings'

export default {
  name: 'ExamSystem',
  components: {
    CommonBreadcrumb,
  },
  props: {
    showStatus: {
      type: Boolean,
      default: false,
    },
    preExamUrl: {
      type: String,
      default: ''
    },
    faqs: {
      type: Array,
      default: () => [],
    },
    blessings: {
      type: Object,
      default: () => ({
        content:
          '今天是#date# <br />考试时间：5月12日至20日。<br />正保建设工程教育网祝您梦想成真！',
      }),
    },
  },
  mixins: [mixinFilter, mixinCl],
  data() {
    return {
      categoryTitle: '',
      flag: '',
    }
  },
  computed: {
    blessingsConvert() {
      return this.blessings.content.replace(/#date#/i, this.currentData)
    },
  },
  mounted() {
    this.categoryTitle = title
    const { flag } = this.$route.params
    this.flag = flag === 'paidExam' ? '' : flag
  },
  methods: {
    startExam() {
      const { courseID, siteCourseID } = this.$route.query
      const { flag } = this.$route.params
      this.$router.push({
        path: `/${flag}/realMockExam`,
        query: {
          siteCourseID: siteCourseID,
          courseID: courseID,
        },
      })
    },
    // 锚点跳转
    custormAnchor(anchorName) {
      this.$emit('update:showStatus', false)
      let anchorElement = document.getElementById(anchorName)
      let fatherElement = document.querySelector('.mrtext')
      this.$nextTick(() => {
        fatherElement.scrollTop = anchorElement.offsetTop - 40
      })
    },
  },
}
</script>
